import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: white,
    marginTop: indent,
  },
  loader: {
    marginTop: indent * 2,
  },
});
